import axios from 'axios';

export default {
  fetchUser({
    commit,
  }, id) {
    return axios.get(`/user/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'user',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  fetchCurrentUser() {
    return axios.get('/user?current=true');
  },
  saveUser(_, user) {
    return axios.post('/user', user);
  },
};
